import Api from 'api/index'

const config = {
  baseURL: '/api/app/v1/payout',
}

const api = new Api(config)

api.calculate = ({ profileId, ...rest }) =>
  api.post(`/${profileId}/calculate`, { ...rest })

api.requestPayout = ({ profileId, ...rest }) =>
  api.post(`/${profileId}/request`, { ...rest })

export default api
